// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../cldr-apps/js/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../cldr-apps/js/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * This file is shared between Charts and SurveyTool
 */

.ReportChart table {
	border-collapse: collapse
}

.ReportChart caption {
	font-size: 150%;
	margin-top: 2em
}

.ReportChart td, .ReportChart  th {
	vertical-align: top;
	text-align: left;
	padding: 0.25em
}

.ReportChart td.source, .ReportChart  th.source, .ReportChart  span.source {
	border: 1px solid #666666;
	background-color: #FCFCFC;
}

.ReportChart  td.source-image {
	border: 1px solid #666666;
	background-color: #FCFCFC;
	text-align: center;
	font-size: 200%;
}

.ReportChart td.target, .ReportChart  th.target, .ReportChart  span.target, .ReportChart  td.targetRight, .ReportChart  td.target2, .ReportChart  td.target3,
.ReportChart  td.target4, .ReportChart  td.target_nofont {
	border: 1px solid #666666;
	background-color: #FCFFFC
}

.ReportChart td.target_nofont {
	/* font-family: sans-serif; */
	line-height: 150%;
}

.ReportChart th.source {
	background-color: #DDDDDD
}

.ReportChart th.target {
	background-color: #ddFFdd
}

.ReportChart td.target2 {
	color: blue
}

.ReportChart td.target3 {
	background-color: #FFFFF8
}

.ReportChart td.target4 {
	background-color: #F8FFFF
}

.ReportChart td.targetRight {
	text-align: right
}

.ReportChart td.z0 {
	border: 1px solid #666666;
	background-color: #FCBBFC
}

.ReportChart td.z1 {
	border: 1px solid #666666;
	background-color: #FCCCFC
}

.ReportChart td.z2 {
	border: 1px solid #666666;
	background-color: #FCDDFC;
	vertical-align: middle
}

.ReportChart td.z3 {
	border: 1px solid #666666;
	background-color: #FCEEFC;
	vertical-align: middle
}

.ReportChart td.z4 {
	border: 1px solid #666666;
	background-color: #FCFFFC;
	vertical-align: middle
}

.ReportChart h2, .ReportChart h3, .ReportChart h4 {
	text-align: left
}

.ReportChart td.l, .ReportChart td.z, .ReportChart td.o, .ReportChart td.t, .ReportChart td.f, .ReportChart td.m,.ReportChart  td.x, .ReportChart th.h, .ReportChart table.pluralComp {
	border: 1px solid #666;
	font-size: 8pt
}

.ReportChart table.pluralComp {
	border-collapse: collapse
}

.ReportChart th.h {
	background-color: #EEE;
	border-top: 2px solid #000;
	border-bottom: 2px solid #000;
	text-align: center;
	font-size: 6pt
}

.ReportChart td.l {
	background-color: #EFE;
	border-top: 2px solid #000
}

.ReportChart td.z {
	background-color: #F00
}

.ReportChart td.o {
	background-color: #DD0
}

.ReportChart td.t {
	background-color: #0F0
}

.ReportChart td.f {
	background-color: #0DD
}

.ReportChart td.m {
	background-color: #99F
}

.ReportChart td.x {
	background-color: #CCC
}

.ReportChart td.c01 {
	text-decoration: underline
}

.ReportChart td.sample {
	font-size: 200%;
	text-align: center
}

.ReportChart .nowrap {
	white-space: nowrap
}

.ReportChart .notTailored {
	color: #888888;
}

.ReportChart .notExemplars {
	color: #c0ffee;
}

.ReportChart table.center {
	margin-left: auto;
	margin-right: auto;
}

.ReportChart td.plain {
	padding-top: 0.3em;
	padding-right: 1em;
}

.ReportChart #chits {
	display: flex;
	flex-flow: row wrap;
}

.ReportChart .chit {
	border-collapse: separate;
	color: black;
	background-color: white;
	display: inline-block;
	margin: 1px;
	padding: 1px;
	width: 200px;
	height: 40px;
	border-radius: 5px;
	overflow: hidden;
	text-overflow: ellipsis;
	vertical-align: middle;
	display: flex;
	align-items: center;
	border: 2px solid #ccc;
}

.ReportChart .version {
    content: "β";
    color: black;
    font-weight: bold;
}
.ReportChart .version::after {
    content: "β";
    color: red;
    font-weight: bold;
}


.ReportChart .versionDate {
	display: inline;
	border-width:0;
	padding:0;
	margin:0;
	width:100%;
	height:36px;
	overflow:hidden;
}
.ReportChart .upLink {
	font-weight: bold;
	font-size: 120%;
}

/* formatting for date time review */
.dtf-table, .dtf-int {margin-left:auto; margin-right:auto; border-collapse:collapse;}
.dtf-table, .dtf-s, .dtf-nopad, .dtf-fix, .dtf-th, .dtf-h, .dtf-sep, .dtf-left, .dtf-int {border:1px solid gray;}
.dtf-th {background-color:#EEE; padding:4px}
.dtf-s, .dtf-nopad, .dtf-fix {padding:3px; text-align:center}
.dtf-sep {background-color:#EEF; text-align:center}
.dtf-s {text-align:center;}
.dtf-int {width:100%; height:100%}
.dtf-fix {width:1px}
.dtf-left {text-align:left;}
.dtf-nopad {padding:0px; vertical-align:top;}
.dtf-gray {background-color:#EEF}
`, "",{"version":3,"sources":["webpack://./../../cldr-code/src/main/resources/org/unicode/cldr/tool/reports.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;CACC;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;CAChB;AACD;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,kBAAkB;CAClB,eAAe;AAChB;;AAEA;;CAEC,yBAAyB;CACzB;AACD;;AAEA;CACC,6BAA6B;CAC7B,iBAAiB;AAClB;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB;AACD;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB;AACD;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,sBAAsB;CACtB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,sBAAsB;CACtB,0BAA0B;CAC1B,6BAA6B;CAC7B,kBAAkB;CAClB;AACD;;AAEA;CACC,sBAAsB;CACtB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,YAAY;CACZ,uBAAuB;CACvB,qBAAqB;CACrB,WAAW;CACX,YAAY;CACZ,YAAY;CACZ,YAAY;CACZ,kBAAkB;CAClB,gBAAgB;CAChB,uBAAuB;CACvB,sBAAsB;CACtB,aAAa;CACb,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,UAAU;IACV,iBAAiB;AACrB;;;AAGA;CACC,eAAe;CACf,cAAc;CACd,SAAS;CACT,QAAQ;CACR,UAAU;CACV,WAAW;CACX,eAAe;AAChB;AACA;CACC,iBAAiB;CACjB,eAAe;AAChB;;AAEA,oCAAoC;AACpC,sBAAsB,gBAAgB,EAAE,iBAAiB,EAAE,wBAAwB,CAAC;AACpF,0FAA0F,qBAAqB,CAAC;AAChH,SAAS,qBAAqB,EAAE,WAAW;AAC3C,8BAA8B,WAAW,EAAE,iBAAiB;AAC5D,UAAU,qBAAqB,EAAE,iBAAiB;AAClD,QAAQ,iBAAiB,CAAC;AAC1B,UAAU,UAAU,EAAE,WAAW;AACjC,UAAU,SAAS;AACnB,WAAW,eAAe,CAAC;AAC3B,YAAY,WAAW,EAAE,kBAAkB,CAAC;AAC5C,WAAW,qBAAqB","sourcesContent":["/*\n * This file is shared between Charts and SurveyTool\n */\n\n.ReportChart table {\n\tborder-collapse: collapse\n}\n\n.ReportChart caption {\n\tfont-size: 150%;\n\tmargin-top: 2em\n}\n\n.ReportChart td, .ReportChart  th {\n\tvertical-align: top;\n\ttext-align: left;\n\tpadding: 0.25em\n}\n\n.ReportChart td.source, .ReportChart  th.source, .ReportChart  span.source {\n\tborder: 1px solid #666666;\n\tbackground-color: #FCFCFC;\n}\n\n.ReportChart  td.source-image {\n\tborder: 1px solid #666666;\n\tbackground-color: #FCFCFC;\n\ttext-align: center;\n\tfont-size: 200%;\n}\n\n.ReportChart td.target, .ReportChart  th.target, .ReportChart  span.target, .ReportChart  td.targetRight, .ReportChart  td.target2, .ReportChart  td.target3,\n.ReportChart  td.target4, .ReportChart  td.target_nofont {\n\tborder: 1px solid #666666;\n\tbackground-color: #FCFFFC\n}\n\n.ReportChart td.target_nofont {\n\t/* font-family: sans-serif; */\n\tline-height: 150%;\n}\n\n.ReportChart th.source {\n\tbackground-color: #DDDDDD\n}\n\n.ReportChart th.target {\n\tbackground-color: #ddFFdd\n}\n\n.ReportChart td.target2 {\n\tcolor: blue\n}\n\n.ReportChart td.target3 {\n\tbackground-color: #FFFFF8\n}\n\n.ReportChart td.target4 {\n\tbackground-color: #F8FFFF\n}\n\n.ReportChart td.targetRight {\n\ttext-align: right\n}\n\n.ReportChart td.z0 {\n\tborder: 1px solid #666666;\n\tbackground-color: #FCBBFC\n}\n\n.ReportChart td.z1 {\n\tborder: 1px solid #666666;\n\tbackground-color: #FCCCFC\n}\n\n.ReportChart td.z2 {\n\tborder: 1px solid #666666;\n\tbackground-color: #FCDDFC;\n\tvertical-align: middle\n}\n\n.ReportChart td.z3 {\n\tborder: 1px solid #666666;\n\tbackground-color: #FCEEFC;\n\tvertical-align: middle\n}\n\n.ReportChart td.z4 {\n\tborder: 1px solid #666666;\n\tbackground-color: #FCFFFC;\n\tvertical-align: middle\n}\n\n.ReportChart h2, .ReportChart h3, .ReportChart h4 {\n\ttext-align: left\n}\n\n.ReportChart td.l, .ReportChart td.z, .ReportChart td.o, .ReportChart td.t, .ReportChart td.f, .ReportChart td.m,.ReportChart  td.x, .ReportChart th.h, .ReportChart table.pluralComp {\n\tborder: 1px solid #666;\n\tfont-size: 8pt\n}\n\n.ReportChart table.pluralComp {\n\tborder-collapse: collapse\n}\n\n.ReportChart th.h {\n\tbackground-color: #EEE;\n\tborder-top: 2px solid #000;\n\tborder-bottom: 2px solid #000;\n\ttext-align: center;\n\tfont-size: 6pt\n}\n\n.ReportChart td.l {\n\tbackground-color: #EFE;\n\tborder-top: 2px solid #000\n}\n\n.ReportChart td.z {\n\tbackground-color: #F00\n}\n\n.ReportChart td.o {\n\tbackground-color: #DD0\n}\n\n.ReportChart td.t {\n\tbackground-color: #0F0\n}\n\n.ReportChart td.f {\n\tbackground-color: #0DD\n}\n\n.ReportChart td.m {\n\tbackground-color: #99F\n}\n\n.ReportChart td.x {\n\tbackground-color: #CCC\n}\n\n.ReportChart td.c01 {\n\ttext-decoration: underline\n}\n\n.ReportChart td.sample {\n\tfont-size: 200%;\n\ttext-align: center\n}\n\n.ReportChart .nowrap {\n\twhite-space: nowrap\n}\n\n.ReportChart .notTailored {\n\tcolor: #888888;\n}\n\n.ReportChart .notExemplars {\n\tcolor: #c0ffee;\n}\n\n.ReportChart table.center {\n\tmargin-left: auto;\n\tmargin-right: auto;\n}\n\n.ReportChart td.plain {\n\tpadding-top: 0.3em;\n\tpadding-right: 1em;\n}\n\n.ReportChart #chits {\n\tdisplay: flex;\n\tflex-flow: row wrap;\n}\n\n.ReportChart .chit {\n\tborder-collapse: separate;\n\tcolor: black;\n\tbackground-color: white;\n\tdisplay: inline-block;\n\tmargin: 1px;\n\tpadding: 1px;\n\twidth: 200px;\n\theight: 40px;\n\tborder-radius: 5px;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tvertical-align: middle;\n\tdisplay: flex;\n\talign-items: center;\n\tborder: 2px solid #ccc;\n}\n\n.ReportChart .version {\n    content: \"β\";\n    color: black;\n    font-weight: bold;\n}\n.ReportChart .version::after {\n    content: \"β\";\n    color: red;\n    font-weight: bold;\n}\n\n\n.ReportChart .versionDate {\n\tdisplay: inline;\n\tborder-width:0;\n\tpadding:0;\n\tmargin:0;\n\twidth:100%;\n\theight:36px;\n\toverflow:hidden;\n}\n.ReportChart .upLink {\n\tfont-weight: bold;\n\tfont-size: 120%;\n}\n\n/* formatting for date time review */\n.dtf-table, .dtf-int {margin-left:auto; margin-right:auto; border-collapse:collapse;}\n.dtf-table, .dtf-s, .dtf-nopad, .dtf-fix, .dtf-th, .dtf-h, .dtf-sep, .dtf-left, .dtf-int {border:1px solid gray;}\n.dtf-th {background-color:#EEE; padding:4px}\n.dtf-s, .dtf-nopad, .dtf-fix {padding:3px; text-align:center}\n.dtf-sep {background-color:#EEF; text-align:center}\n.dtf-s {text-align:center;}\n.dtf-int {width:100%; height:100%}\n.dtf-fix {width:1px}\n.dtf-left {text-align:left;}\n.dtf-nopad {padding:0px; vertical-align:top;}\n.dtf-gray {background-color:#EEF}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
